import { useContext } from 'react';

import {
  SidekickApiContext,
  type SidekickApiContextValue,
} from '../contexts/SidekickApiContext';

/**
 * Reads the host-supplied API configuration (`apiBaseUrl`) from the
 * surrounding {@link SidekickApiProvider}. Used by the orchestrator
 * and the streaming + sync hooks to build conversation-scoped URLs.
 *
 * Throws when no {@link SidekickApiProvider} is mounted on the tree.
 * The integration boundary is {@link SidekickLayoutShell}, which
 * mounts the provider internally when the host passes `apiBaseUrl` —
 * so a missing-provider error means the host has not threaded
 * `apiBaseUrl` through the shell yet, not that the hook was called
 * incorrectly.
 */
export const useSidekickApi = (): SidekickApiContextValue => {
  const value = useContext(SidekickApiContext);
  if (value === null) {
    throw new Error('useSidekickApi must be used within a SidekickApiProvider');
  }
  return value;
};
